import { render, staticRenderFns } from "./ServiceTask.vue?vue&type=template&id=2a8acc26"
import script from "./ServiceTask.vue?vue&type=script&lang=js"
export * from "./ServiceTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports